module.exports = __webpack_public_path__ + "img/goods12_4.64b910e0.jpg";